import React, { ComponentProps } from 'react';

import Button, { BUTTON_SIZES, BUTTON_TYPES } from '@buyside/components/presentation/Button/button';
import MessageModal, {
  MessageModalProps
} from '@buyside/components/presentation/MessageModal/messageModal';
import EnvelopeIcon from '@buyside/svgs/envelope.svg';

import { accessIdeasUrl } from '@buyside/util/urlHelper';

import { useMainNavigationCurrentUserQuery } from '@interfaces/graphql-typings';

const MessageButton: React.FC<MessageModalProps & {
  buttonOptions?: Partial<ComponentProps<typeof Button>>;
  showUpsell?: boolean;
}> = ({
  buttonOptions,
  receiverEmployerName,
  isCurrentEmployer,
  receiverId,
  receiverName,
  showUpsell
}) => {
  const { data, loading } = useMainNavigationCurrentUserQuery();

  if (loading || !data?.currentUser) return null;

  const { canAccessMessages, canManageMessages, isAllocator, isRetail } = data.currentUser;

  if (!canAccessMessages || isRetail || isAllocator) return null;
  if (!canManageMessages && !showUpsell) return null;

  return canManageMessages ? (
    <MessageModal
      buttonOptions={buttonOptions}
      isCurrentEmployer={isCurrentEmployer}
      receiverEmployerName={receiverEmployerName}
      receiverId={receiverId}
      receiverName={receiverName}
    />
  ) : (
    <Button
      icon={EnvelopeIcon}
      size={BUTTON_SIZES.TINY}
      text="Message"
      type={BUTTON_TYPES.SECONDARY}
      url={accessIdeasUrl()}
    />
  );
};

export default MessageButton;
